var exports = {
  "q": "GuildAcronym.module__acronym___MXlfaG",
  "Q": "GuildAcronym.module__text___MXlfaG",
};

module.exports = exports;
